module.exports = __webpack_public_path__ + "static/img/pin-larvicide-scheduled-mandatory.f90e5ba.svg";